<template>
	<div class="project-boxes">

		<ExplanationTitle heading="Your Forms" explanation="You can accept submissions on your project through multiple forms."></ExplanationTitle>

		<div class="row">

			<!-- Loading effect -->
			<div class="col-lg-3 col-xl-3" v-if="!forms.loaded">
				<FormBox></FormBox>
			</div>
			<div class="col-lg-3 col-xl-3" v-if="!forms.loaded">
				<FormBox></FormBox>
			</div>
			<div class="col-lg-3 col-xl-3" v-if="!forms.loaded">
				<FormBox></FormBox>
			</div>

			<!-- Forms -->
			<div class="col-lg-4 col-xl-3" v-for="(form, key) in forms.items" :key="key">
				<FormBox :data="form"></FormBox>
			</div>

            <!-- New Form -->
            <div class="col-lg-4 col-xl-3" v-if="forms.loaded && forms.items.length <= 3">
                <div class="new-form" @click.prevent="$root.$emit('openNewFormPopup')">
                    <img src="../../assets/icons/new-form.svg" alt="Folder" class="icon">
                    <h5>Create New Form</h5>
                    <p>You can accept submissions on your project through multiple forms.</p>
                </div>
            </div>

<!--			&lt;!&ndash; If more than 3 forms, show view more &ndash;&gt;-->
<!--			<router-link to="/forms" class="col-md-4 col-lg-4 col-xl-3 show-more-products d-none d-md-flex" v-if="forms.loaded && forms.items.length > 4">-->
<!--				<span class="btn btn-primary">Show all forms</span>-->
<!--			</router-link>-->
		</div>

	</div>
</template>

<script>
import FormBox from "@/components/models/FormBox";
import repository from "@/repository/repository";
import ExplanationTitle from "../widgets/ExplanationTitle";

export default {
    name: "FormBoxes",
    components: {ExplanationTitle, FormBox},
    computed: {
        forms() {
            return this.$store.getters.forms;
        },
        currentProject() {
            return this.$store.getters.currentProject;
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

.project-boxes {

	.row {
		//white-space: nowrap;
		//flex-wrap: nowrap;
		//overflow: hidden;
		//position: relative;
        //
		//.col-md-4.show-more-products {
		//	position: absolute;
		//	top: 0;
		//	right: 0;
		//	display: flex;
		//	flex-direction: column;
		//	align-items: center;
		//	justify-content: center;
		//	bottom: 30px;
		//	background: -moz-linear-gradient(left, rgba(242, 244, 249, 0.75) 0%, rgba(242, 244, 249, 1) 75%, rgba(242, 244, 249, 1) 100%);
		//	background: -webkit-linear-gradient(left, rgba(242, 244, 249, 0.75) 0%, rgba(242, 244, 249, 1) 75%, rgba(242, 244, 249, 1) 100%);
		//	background: linear-gradient(to right, rgba(242, 244, 249, 0.75) 0%, rgba(242, 244, 249, 1) 75%, rgba(242, 244, 249, 1) 100%);
		//	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#bff2f4f9', endColorstr='#f2f4f9', GradientType=1);
		//	z-index: 1;
		//	text-decoration: none;
		//}
	}

	.new-form {
		display: block;
		background: $background-white;
		border-radius: $box-border-radius;
		padding: 25px;
		box-shadow: $box-shadow-color 0 2px 3px;
		position: relative;
		overflow: hidden;
		margin-bottom: 30px;
		height: calc(100% - 30px);
		white-space: normal;
		text-decoration: none;
        cursor: pointer;

		@include smartphone {
			padding: 15px 15px 15px 60px;
		}

		@extend .animated;

		&:hover {
			box-shadow: $box-shadow-color 0 5px 10px;
		}

		&:active {
            transform-origin: center;
            transform: scale(0.975);
		}

		&:before {
			position: absolute;
			width: 10px;
			height: 100%;
			top: 0;
			left: 0;
			content: ' ';
			z-index: 1;
		}

		img.icon {
			display: block;
            width: 48px;
            border-radius: $box-border-radius;

			@include smartphone {
				position: absolute;
				top: 0;
				bottom: 0;
				left: 15px;
				width: 32px;
				margin: auto;
			}
		}

		h5 {
			font-weight: 600;
			color: $dark;
			font-size: 1.1rem;
			margin: 15px 0 10px 0;

			@include smartphone {
				margin-top: 0;
				margin-bottom: 5px;
			}
		}

		p {
			font-size: 0.9rem;
			color: $grey-text;
			margin: 0;
		}
	}

}
</style>